import { MapPin, Stars, ShieldCheck } from 'lucide-react';
import { useInView } from '../../hooks/useInView';

export const About = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="about" className="section-gap bg-obsidian relative overflow-hidden">
      {/* Subtle warm radial */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber/[0.02] rounded-full blur-[150px]" />

      <div ref={ref} className="relative max-w-7xl mx-auto">
        {/* Section label */}
        <div
          className={`mb-16 md:mb-20 transition-all duration-900 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
          }>

          <div className="flex items-center gap-4 mb-4">
            <div className="gold-line" />
            <span className="font-body text-[11px] tracking-[0.4em] uppercase text-amber/50">
              The Experience
            </span>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image - takes 7 columns */}
          <div
            className={`lg:col-span-7 relative transition-all duration-[1.1s] ${
            isInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`
            }>

            <div className="relative">
              <img
                src="https://acpx.in/About.webp"
                alt="Outdoor cinema under the stars"
                className="w-full h-[400px] md:h-[540px] object-cover rounded-sm" />

              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/40 via-transparent to-transparent rounded-sm" />
              {/* Floating detail */}
              <div className="absolute -bottom-6 right-6 md:right-10 glass rounded-sm px-6 py-4">
                <p className="font-heading !font-sans !font-light !text-base text-amber">4.8</p>
                <p className="font-body text-[10px] text-ivory/40 tracking-wider uppercase">Guest Rating</p>
              </div>
            </div>
          </div>

          {/* Text - takes 5 columns */}
          <div
            className={`lg:col-span-5 pt-4 transition-all duration-[1.1s] delay-200 ${
            isInView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`
            }>

            <h2 className="font-heading text-[2.5rem] md:text-[3.2rem] lg:text-[3.8rem] font-light leading-[1.05] text-ivory mb-8">
              Where Nature
              <br />
              Meets <em className="text-amber italic">Cinema</em>
            </h2>

            <div className="space-y-5 mb-12">
              <p className="font-body !font-light !leading-[1.8rem] text-[15px] text-ivory/35">Imagine watching your favourite classics under a canopy of stars, with the gentle sound of a waterfall in the distance and hills silhouetted against the night sky.



              </p>
              <p className="font-body !font-light !leading-[1.8rem] text-[15px] text-ivory/35">Bring your own car, or choose a private space with comfortable seating. And yes, you can bring your own booze. This is your evening, your way.


              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3">
              {[
              { icon: MapPin, value: '35 min', label: 'From Guwahati' },
              { icon: Stars, value: 'Open Sky', label: 'Under the Stars' },
              { icon: ShieldCheck, value: 'Private', label: 'Enclosed Spaces' }].
              map((stat, i) =>
              <div key={i} className="text-center py-5 border border-amber/[0.06] rounded-sm">
                  <stat.icon size={16} className="text-amber/50 mx-auto mb-2.5" />
                  <p className="font-heading text-lg font-medium text-ivory/80">{stat.value}</p>
                  <p className="font-body text-[10px] text-ivory/25 tracking-wider uppercase mt-0.5">{stat.label}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

};